export default "__VITE_ASSET__B3KO1cA4__"